import React from "react";
import CardWrapper from "../common/cardWrapper";
import Button from "../common/Button";
import GuestProfile from "../common/guestProfile";

const LanguageContactHostCard = (props) => {
  // iski styling CardWrappe.scss me hai ----------
  return (
    <CardWrapper wrapperClass="language-contact-card">      
      {/* <GuestProfile
            profileName={props.profileName}
            whoseProfile={props.profileSub}
            profileImg={props.profilePic}
        /> */}
        <p>Languages: <span>{props.languages}</span></p>
        <p>Response rate: <span>{props.responseRate}</span></p>
        <p>Respose time <span>{props.responseTime}</span></p>
        
      <Button onClick={props.onClick} btnText="Message host"  btnclasses="contact-btn" />
      <div className="protection-payment-text-box">
        <img src="./assets/img/protectionIcon.svg" alt="" />
        <p>For payment protection, stick to Jumbo Holidays website or app.</p>
      </div>
    </CardWrapper>
  );
};

export default LanguageContactHostCard;
